import React, { useState } from 'react'
import Navbar from '../../../components/Navbar/Navbar'
import { useNavigate } from "react-router-dom";
import { HiOutlineChevronLeft } from "react-icons/hi";
import Prescriptions from './tabs/Prescriptions';
import Invoices from './tabs/Invoices';

function Prescription() {

    //tab states
    const [tab, setTab] = useState(1);

    const navigate = useNavigate()

    const goBack = () => {
        navigate(-1);
    };

    return (
        // <div className="Home bg-Light-gray min-h-screen w-full">
    <div className="min-h-screen w-full">
            {/* <Navbar heading="Home / Prescriptions and Invoices" /> */}
            <div className='px-3 flex flex-col gap-4'>
                {/* ---header---- */}
                <div className="flex text-text  items-center justify-between ">
                    <div className='flex items-center gap-2'>
                        <div
                            className="bg-white rounded-lg cursor-pointer p-2 mx-3 shadow-back text-lg font-bold"
                            onClick={goBack}
                        >
                            <HiOutlineChevronLeft />
                        </div>
                        <h1 className="text-lg font-bold">{tab === 1 ? 'Prescriptions' : 'Invoices'}</h1>
                    </div>
                    {/* ---tab selector--- */}
                    <div className='flex items-center gap-4'>
                        {/* <button type='button' onClick={() => setTab(1)} className={`${tab === 1 ? 'font-bold border-b-2 border-primary-500' : ''}  `} >Prescriptions</button>
                        <button type='button' onClick={() => setTab(2)} className={`${tab === 2 ? 'font-bold border-b-2 border-primary-500' : ''}  `} >Invoices</button> */}
                        <button type='button' onClick={() => setTab(1)} className={`${tab === 1 ? 'font-bold border-b-2 border-[#01A1FF]' : ''}  `} >Prescriptions</button>
                        <button type='button' onClick={() => setTab(2)} className={`${tab === 2 ? 'font-bold border-b-2 border-[#01A1FF]' : ''}  `} >Invoices</button>
                    </div>
                </div>

                {/* ----tables---- */}
                <div>
                    {
                        tab === 1 ? <Prescriptions /> : <Invoices />
                    }
                </div>
            </div>
        </div>
    )
}

export default Prescription